/**
 * A simple call function that can call a function and passing arguments
 * just if the function it's a valid function.
 * @param func
 * @param parameters
 */
export function call<T extends (...args: any) => any>(
    func: T | undefined,
    ...parameters: Parameters<T>
): undefined | ReturnType<T> {
    if (func && typeof func === 'function') {
        return func.apply(func, parameters);
    }

    return undefined;
}
